function setFrontBackToggleCameras(configurator, bladeSide) {
  configurator.setConfiguration({
    '3D Animations': `${bladeSide} Toggle Selected`,
  });
}

function setLinerCamera(configurator) {
  configurator.setConfiguration({
    '3D Animations': `Backspacer/Liner Selected`,
  });
}

export function setExitBladeView(configurator) {
  configurator.setConfiguration({
    '3D Animations': 'Exit Blade View',
  });
}

export async function setMobileAndDesktopView(
  configurator,
  player,
  bladeSide,
  previousBladeSide,
  drawerCategory,
  previousDrawerCategory,
) {
  const setView = async (mobileViewOrientation) => {
    await configurator.setConfiguration({
      Camera: '',
      'Change camera': '',
      '3D Animations': '',
    });
    await configurator.setConfiguration({
      'Mobile View Orientation': mobileViewOrientation,
    });

    // Helps the transition between blade and handle views
    if (drawerCategory === 'Color & Material' && mobileViewOrientation) {
      configurator.setConfiguration({
        '3D Animations': 'Exit Blade View',
      });
    }

    if (bladeSide !== previousBladeSide) {
      setFrontBackToggleCameras(configurator, bladeSide);
    }
    if (drawerCategory === 'Liner' || drawerCategory === 'Backspacer') {
      setLinerCamera(configurator);
    } else if (
      previousDrawerCategory === 'Liner' ||
      previousDrawerCategory === 'Backspacer'
    ) {
      configurator.setConfiguration({
        '3D Animations': 'Exit Backspacer/Liner Selected View',
      });
      setFrontBackToggleCameras(configurator, bladeSide);
    }
  };

  if (window.innerWidth < 1024) {
    await setView(true);
    player.tools.removeTool('zoom');
  } else {
    await setView(false);
    player.tools.addTool('zoom');
  }
}

export async function setBladeView(configurator, player, bladeSide) {
  if (window.innerWidth < 1024) {
    if (bladeSide === 'Front') {
      await configurator.setConfiguration({
        '3D Animations': 'Blade Selection',
      });
    } else {
      await configurator.setConfiguration({
        '3D Animations': 'Back Blade Selection',
      });
    }
    player.tools.removeTool('zoom');
  } else {
    configurator.setConfiguration({
      'Mobile View Orientation': false,
      '3D Animations': 'Enter Blade View',
      Camera: `${bladeSide}_PC_Cam`,
    });
    player.tools.addTool('zoom');
  }
}

export async function set2DMobileAndDesktopView(configurator) {
  if (window.innerWidth < 1024) {
    await configurator.setConfiguration({
      'Change camera': 'Camera angle to blade',
    });
  } else {
    configurator.setConfiguration({
      'Change camera': 'Camera angle to knife',
    });
  }
}
